import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-link-disabled-dialog-box',
    standalone: true,
    imports: [MatIconModule],
    templateUrl: './link-disabled-dialog-box.component.html',
    styleUrl: './link-disabled-dialog-box.component.scss'
})
export class LinkDisabledDialogBoxComponent {


    constructor(
        private dialogRef: MatDialogRef<LinkDisabledDialogBoxComponent>,
    ) { }

    closeDialog(): void {
        this.dialogRef.close(false);
    }

    confirm(){
        this.dialogRef.close(true);
    }

}
